// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { List as RaList } from '@react-admin/ra-rbac';
import { merge } from 'lodash';
import { ReactElement, useEffect } from 'react';
import {
  ListProps,
  RecordContextProvider,
  useRemoveFromStore,
  useResourceContext,
} from 'react-admin';

import { Pagination } from '@sh4res/bo-common/components';
import { PageTitle } from '@sh4res/bo-common/components/PageTitle';

export const List = (props: ListProps & { children: ReactElement; pageTitle?: string }) => {
  const { pageTitle, ...rest } = props;

  // `props.resource` must win over the context: for a list embedded in a Show page the surrounding
  // ResourceContext is the parent resource, not the list's own.
  const resource = useResourceContext(props);
  const remove = useRemoveFromStore();
  // Removing the saved filters
  useEffect(() => {
    remove(`${resource}.listParams`);
  }, [resource, remove]);

  const sx = merge(
    {
      height: '100%',
      '& .RaList-actions': {
        justifyContent: 'unset',
        flexWrap: 'wrap',
      },
      '& .RaList-actions form': {
        display: 'contents',
      },
      '& .MuiToolbar-root': {
        width: 'unset',
      },
      '& .RaList-main': {
        height: '100%',
        minHeight: 0,
      },
      '& .RaList-main > *': {
        flexShrink: 0,
      },
      '& .RaList-content': {
        flex: '0 1 auto',
        minHeight: 0,
        overflow: 'hidden',
      },
    },
    rest.sx,
  );

  return (
    <>
      <PageTitle title={pageTitle} />
      <RecordContextProvider value={undefined}>
        <RaList pagination={<Pagination />} {...rest} sx={sx} />
      </RecordContextProvider>
    </>
  );
};
